/* eslint-disable import/no-anonymous-default-export */
import { SET_DARK_MODE } from '../actionConstants';

export default (state = true, action) => {
  switch (action.type) {
    case SET_DARK_MODE:
      return action.payload;
    default:
      return state;
  }
};
